import { CopyOutlined, DeleteOutlined, DownOutlined, SyncOutlined } from '@ant-design/icons';
import { Button, Dropdown, Menu, message, Popconfirm, Tooltip } from 'antd';
import _ from 'lodash';
import * as React from 'react';
import { connect } from 'react-redux';
import { AnyAction } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { isDefined } from '../../reducers/util';
import SparkQueryStatus from '../SparkQueryStatus';
import { copyReport, deleteReport, loadReport } from './actions/index';
import { SavedReport } from './types/SavedReport';

interface Props {
    savedReports: SavedReport[];
    loadReport(reportId: number): any;
    copyReport(reportId: number): any;
    deleteReport(reportId: number): any;
}

const SavedReportMenu = ({ savedReports, loadReport, copyReport, deleteReport }: Props) => {

    function handleMenuClick(e: any) {
        const clickedReport: SavedReport | undefined = _.find(savedReports, function (i) {
            return i.id === parseInt(e.key)
        })
        if (!_.isNil(clickedReport)) {
            loadReport(clickedReport.id)
        }
    }

    function menu() {
        if (isDefined(savedReports)) {
            return (
                <Menu onClick={handleMenuClick}>
                    {savedReports.map(i => {
                        return (
                            <Menu.Item key={i.id}>
                                <SparkQueryStatus type="report" status={i.status!} /> {i.title}&nbsp;&nbsp;
                                <Tooltip title='copy report'>
                                    <CopyOutlined
                                        onClick={e => { e.stopPropagation(); copyReport(i.id); message.info('HRU report copied and selected.'); }} />
                                </Tooltip>&nbsp;
                                <div style={{ display: 'inline-block' }} onClick={(e) => e.stopPropagation()}>
                                    <Popconfirm
                                        overlayStyle={{ zIndex: 2000 }}
                                        placement="left"
                                        title="Are you sure you want to delete this?"
                                        onConfirm={() => { deleteReport(i.id); message.info('HRU report deleted.'); }}
                                        okText="Yes"
                                        cancelText="No">
                                        <Tooltip title='delete report'>
                                            <DeleteOutlined />
                                        </Tooltip>
                                    </Popconfirm>
                                </div>
                            </Menu.Item>
                        );
                    })}
                </Menu>
            );
        } else {
            return (
                <Menu>
                    <Menu.Item key="-1">
                        <SyncOutlined spin />
                    </Menu.Item>
                </Menu>
            );
        }

    }

    return (
        <Dropdown overlay={menu}>
            <Button size="small" >
                Saved <DownOutlined />
            </Button>
        </Dropdown>
    );
}

const mapStateToProps = (state: any, ownProps: any) => {
    return {
        savedReports: state.hru.reports,
        ...ownProps
    }
}

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => {
    return {
        loadReport: (reportId: number) => dispatch(loadReport(reportId)),
        copyReport: (reportId: number) => dispatch(copyReport(reportId)),
        deleteReport: (reportId: number) => dispatch(deleteReport(reportId))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SavedReportMenu)